import React from "react";
import ModalWrap from "./ModalWrap";
import "./logoutconfirmation.scss";
import logoutAlert from "../../assets/images/logoutAlert.svg";
import { Typography } from "@mui/material";
import { logoOut } from "../../services/websiteApi";
import { getParams, isProd } from "../../utlis/helpers";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../state/actions/globalAction";
import { pageLocale } from "../../utlis/locale";

const LogoutConfirmation = ({ logout, setlogout }) => {
  const { accessToken, locale } = getParams();
  const dispatch = useDispatch();
  const { logout_confirmation, logoutText, cancel } = pageLocale("popup");
  const logoutHandler = () => {
    dispatch(setAPILoader(true));
    logoOut({ globalSignOut: false, token: accessToken })
      .then(() => {
        sessionStorage.clear();
        window.location.href = isProd
          ? `https://signin.seniorlife.ai/login?locale=${locale}`
          : `https://signin.dev.seniorlife.io/login?locale=${locale}`;
        dispatch(setAPILoader(false));
        setlogout();
      })
      .catch(() => {
        dispatch(setAPILoader(false));
      });
  };
  return (
    <ModalWrap
      className="logout-confirm-wrapper"
      open={logout}
      onClose={() => setlogout()}
    >
      <div className="logout-content">
        <img src={logoutAlert} alt="logout" className="img" />
        <Typography className="text">{logout_confirmation}</Typography>
        <button className="log-btn" onClick={() => logoutHandler()}>
          {logoutText}
        </button>
        <button className="cancel-btn" onClick={() => setlogout()}>
          {cancel}
        </button>
      </div>
    </ModalWrap>
  );
};

export default LogoutConfirmation;
